import React, { useEffect, useRef } from 'react';
import { Platform, Text, View } from 'react-native';
import LottieView from 'lottie-react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';

const EmptyListPlaceholder = ({ textColor = null, spacing = 100, size = 150, message = "Aww Man! Looks like theres nothing here!", type = null, noLottie = false, icon = null, iconColorVariant = 'textSecondary' }) => {
    const animation = useRef(null);
    
    useEffect(() => {
        if(type == "tasks"){
            animation.current?.play(60, 230);
        }
        else{
            animation.current?.play();
        }
    }, []);

    const DEFAULT_LOTTIE = require('../../assets/Empty_lottie.json');
    const CALENDAR_LOTTIE = require('../../assets/Calendar_lottie.json');
    const TASKS_LOTTIE = require('../../assets/Tasks_lottie.json');
    const COMPLETE_LOTTIE = require('../../assets/Complete_lottie.json');
    const NOT_FOUND_LOTTIE = require('../../assets/404_lottie.json');

    const source = type == "events" ? CALENDAR_LOTTIE :
        type == "tasks" ? TASKS_LOTTIE :
        type == "complete" ? COMPLETE_LOTTIE :
        type == "404" ? NOT_FOUND_LOTTIE :
        DEFAULT_LOTTIE

    // A plain icon wins over any lottie source — for callers that want a
    // quieter, non-animated empty state without dropping the message layout.
    const showIcon = !!icon;
    const showLottie = !noLottie && !showIcon;

    return(
        <View style={styles.container(spacing)}>
            {showIcon &&
                <View style={styles.iconContainer}>
                    <Unicon name={icon} size={Math.min(size, 56)} colorVariant={iconColorVariant} />
                </View>
            }
            {showLottie &&
                <View style={styles.lottieContainer(size)}>
                    <LottieView
                        autoPlay
                        loop={false}
                        ref={animation}
                        style={{
                            width: size,
                            height: size,
                            // backgroundColor: '#eee',
                        }}
                        // Find more Lottie files at https://lottiefiles.com/featured
                        source={source}
                    />
                </View>
            }

            <Text style={styles.message(textColor)}>{message}</Text>
        </View>
    )
}

const styles = StyleSheet.create(({colors}) => ({
    container: (spacing) => ({
        alignItems:"center", 
        justifyContent:"center", 
        width:"100%", 
        marginVertical:spacing, 
        paddingHorizontal:10
    }),
    message: (textColor) => ({
        color:textColor ? textColor : colors.textSecondary, 
        fontStyle:"italic", 
        textAlign:"center", 
        fontSize:15, 
        paddingTop:0, 
        opacity:0.7
    }),
    lottieContainer: (size) => ({
        ...((Platform.OS === 'web') ? {
            width: size * 3,
            height: size * 1.67
        } : {})
    }),
    iconContainer: {
        marginBottom: 8,
        opacity: 0.8,
    }
}));

export default EmptyListPlaceholder